import Dom from '../utility/dom';

/**
 * Set window width css variable
 */
export default function setCustomProperties() {
  const setCSSProps = () => {
    // Window Size Helpers
    // On the front end, measure and set to the body, in the editor, set it off of .editor-styles-wrapper
    const el = Dom.body.classList.contains('is-editor') ? Dom.body.querySelector('.editor-styles-wrapper') : Dom.body;
    el.style.setProperty('--window-width', el.clientWidth + 'px');
    el.style.setProperty('--window-height', window.innerHeight + 'px');
    el.style.setProperty('--window-width-int', el.clientWidth);
    el.style.setProperty('--window-height-int', window.innerHeight);
    
    // Hero sizes
    const hero = Dom.body.querySelector('.hero');
    if(hero){
      Dom.body.style.setProperty('--hero-height', hero.clientHeight + 'px');
      Dom.body.style.setProperty('--hero-height-int', hero.clientHeight);
      
      const heroContainer = hero.querySelector('.hero__container');
      if(heroContainer){
        Dom.body.style.setProperty('--hero-container-height', heroContainer.clientHeight + 'px');
        Dom.body.style.setProperty('--hero-container-height-int', heroContainer.clientHeight);
      }
    }

    // if in the editor, watch for changes to the content and update hero sizes
    if(Dom.body.classList.contains('is-editor')){
      const observer = new MutationObserver((mutationsList, observer) => {
        for(const mutation of mutationsList) {
          if (mutation.type === 'childList' || mutation.type === 'subtree' || mutation.type === 'attributes') {
            setCSSProps();
            break;
          }
        }
      });
      observer.observe(hero, { attributes: true, childList: true, subtree: true });
    }
  }
  setCSSProps();

  window.addEventListener('resize', function(){
    setCSSProps();
  });
}